// extracted by mini-css-extract-plugin
export default {"overlay":"ImagePriview_overlay__TCvlZ","modal":"ImagePriview_modal__cKi6k","previewImage":"ImagePriview_previewImage__Gk8cH","closeButton":"ImagePriview_closeButton__BQhGO"};